import { render, staticRenderFns } from "./MinorPolicy.vue?vue&type=template&id=bc8a7990"
import script from "./MinorPolicy.vue?vue&type=script&lang=js"
export * from "./MinorPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports